import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, get } from 'lodash';
import {
  PENDING_AUTHORIZATION_CASE_ACCESS_MESSAGE,
  shouldBlockPendingAuthorizationCaseAccess,
} from 'src/components/Cases/utils/pendingAuthorizationAccess';

const DEFAULT_UNAUTHORIZED_MESSAGE_TEXT = 'You do not have authorization to view.';

const UnauthorizedMessage = ({ clickedDataObj, currentProviderId, isCaseManager }) => {
  const shouldShowPendingAuthMessage = shouldBlockPendingAuthorizationCaseAccess({
    serviceCase: clickedDataObj,
    currentProviderId,
    isCaseManager,
  });

  const objMessages = shouldShowPendingAuthMessage ?
    [PENDING_AUTHORIZATION_CASE_ACCESS_MESSAGE] :
    get(clickedDataObj, 'permissions.can_view.message', []);
  const messages = isEmpty(objMessages) ?
    [DEFAULT_UNAUTHORIZED_MESSAGE_TEXT] :
    objMessages;

  return (
    <div className="unauthorized-message">
      {
        messages.map((message, i) => (
          <p key={i} className="no-margin">
            {message}
          </p>
        ))
      }
    </div>
  );
};

UnauthorizedMessage.propTypes = {
  clickedDataObj: PropTypes.shape({
    permissions: PropTypes.shape({
      can_view: PropTypes.shape({
        message: PropTypes.array,
      }),
    }),
  }),
  currentProviderId: PropTypes.string,
  isCaseManager: PropTypes.bool,
};

UnauthorizedMessage.defaultProps = {
  clickedDataObj: {},
  currentProviderId: '',
  isCaseManager: false,
};

export default UnauthorizedMessage;
